import React from "react";
import toast from "react-hot-toast";
import useApi from "../useApi";
import { PegGraphRes } from "../patients/index.type";

const useFetchPdiGraphPage = (billingCycleId: string) => {
  const [pdiGraph, setPdiGraph] = React.useState<PegGraphRes | null>(null);

  const { loading: pdiGraphLoading, makeApiCall } = useApi({
    url: `/rtm/patient-dashboard/cron/pdf/v3/pdi-chart/${billingCycleId}`,
    method: "GET",
    preAuth: true,
  });

  const getPdiGraphData = async () => {
    if (!billingCycleId) return;

    const { response } = await makeApiCall<undefined, PegGraphRes>();

    if (response?.status === "success") {
      setPdiGraph(response);
    } else {
      setPdiGraph(null);
    }
  };

  return {
    pdiGraph,
    getPdiGraphData,
    pdiGraphLoading,
  };
};

export default useFetchPdiGraphPage;
